import * as React from "react";

interface HomePanelSectionProps {
  isLoading: boolean;
  isError: boolean;
  loadingText: string;
  errorText: string;
  showDivider?: boolean;
  children: React.ReactNode;
}

export function HomePanelSection({
  isLoading,
  isError,
  loadingText,
  errorText,
  showDivider = false,
  children,
}: HomePanelSectionProps) {
  return (
    <>
      {isLoading && (
        <div className="flex flex-1 items-center justify-center">
          <p className="text-sm text-neutral-400">{loadingText}</p>
        </div>
      )}
      {isError && (
        <div className="flex flex-1 items-center justify-center">
          <p className="text-danger-500 text-sm">{errorText}</p>
        </div>
      )}
      {!isLoading && !isError && <div className="flex items-center justify-center">{children}</div>}
      {showDivider && <div className="my-3 h-px w-full border-b border-neutral-100" />}
    </>
  );
}
